"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApplicationStateLoader = void 0;
const ApplicationState_1 = require("./ApplicationState");
const Service_1 = require("./Service");
const react_1 = require("react");
/**
 * Load, track and access an application state value.
 * */
const useApplicationStateLoader = (config) => {
    const { identifier, remoteProcedureCall, resetOnError = false, onLoadComplete, manual = false, } = config;
    const { args = [] } = remoteProcedureCall;
    const argsRef = (0, react_1.useRef)(args);
    argsRef.current = args;
    const [cacheValidity, setCacheValidity] = (0, react_1.useState)({});
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [latestError, setLatestError] = (0, react_1.useState)();
    const { onChange, setModified } = (0, ApplicationState_1.useApplicationStateValue)(identifier);
    const invalidate = (0, react_1.useCallback)(() => {
        setCacheValidity({});
    }, []);
    const makeRemoteProcedureCall = (0, react_1.useCallback)((...directArgs) => __awaiter(void 0, void 0, void 0, function* () {
        let success;
        setLoading(true);
        setLatestError(undefined);
        try {
            const { serviceConfig, path } = remoteProcedureCall;
            const result = yield (0, Service_1.sendServiceRequest)(serviceConfig, path, directArgs);
            success = true;
            onChange(result);
            setModified(false);
        }
        catch (error) {
            success = false;
            setLatestError(error);
            if (resetOnError) {
                onChange(undefined);
                setModified(false);
            }
        }
        setLoading(false);
        onLoadComplete === null || onLoadComplete === void 0 ? void 0 : onLoadComplete(success);
    }), [remoteProcedureCall, onChange, setModified, resetOnError, onLoadComplete]);
    const appStateLoader = (0, react_1.useMemo)(() => ({
        loading,
        latestError,
        invalidate,
        makeRemoteProcedureCall,
    }), [loading, latestError, invalidate, makeRemoteProcedureCall]);
    (0, react_1.useEffect)(() => {
        if (!manual && argsRef.current) {
            makeRemoteProcedureCall(...argsRef.current);
        }
    }, [cacheValidity, manual, makeRemoteProcedureCall]);
    return appStateLoader;
};
exports.useApplicationStateLoader = useApplicationStateLoader;
